import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import DashboardPageUI from './DashboardPageUI'
import { getRepairingTicketApi, StatusCountChangeApi } from '../../apis/repairing.api'
import { openModal } from '../../store/actions/modalAction';
import { useDispatch, useSelector } from 'react-redux';
import { callApiAction } from '../../store/actions/commonAction';
import moment from 'moment';
import { Box, Chip, IconButton, Tooltip, Typography } from '@mui/material';
import { Edit, Visibility } from '@mui/icons-material';
import CustomerInformation from './CustomerInformation';
import { BUTTON_TYPE, STATUS, USER_ROLES } from '../../utils/constants';
import UpdateCreateQueryController from './UpdateCreateQueryController';
import { statusAction, statusActionFilters, statusCountActionFilters } from '../../store/actions/statusAction';
import { toTitleCase } from '../../utils/main';

const ActionComponent = memo(({ params, setParams, statusPass }) => {
  const dispatch = useDispatch()

  const onEdit = () => {
    dispatch(openModal(<UpdateCreateQueryController id={params._id} statusPass={statusPass === STATUS.ALL ? params?.status[0]?.status_role :statusPass}
    />, "md", false, "UpdateQuery"))
  }

  const onInfo = () => {
    dispatch(
      openModal(
        <CustomerInformation id={params?._id} statusPass={statusPass} />
        ,
        "md",
        false,
        "CustomerInformation"
      )
    );
  };

  const All = statusPass === STATUS.ALL && [STATUS.YET_TO_RECEIVED,STATUS.DISPATCH].includes(params?.status[0]?.status_role) 
  // const ALLOTP = CRMstatusButton===BUTTON_TYPE.Solved && statusPass === STATUS.ALL && [STATUS.YET_TO_RECEIVED,STATUS.DISPATCH].includes(params?.status[0]?.status_role) 

  return <Box sx={{ width: "100%", alignItems: "flex-start", display: "flex" }}>
    <Tooltip title={"Customer Information"}>
      <IconButton size="inherit" onClick={onInfo}>
        <Visibility color="info" fontSize="inherit" />
      </IconButton>
    </Tooltip>

    {((statusPass === STATUS.YET_TO_RECEIVED) || (statusPass === STATUS.DISPATCH) || All) && <IconButton size="inherit" onClick={onEdit}>
      <Edit color="info" fontSize="inherit" />
    </IconButton>}
  </Box>
})

const DashboardPageControllerLD = () => {
  const dispatch = useDispatch();
  const [LDstatusButton, setLDstatusButton] = useState(BUTTON_TYPE.pending)
  const [STATUSWiseData, setSTATUSWiseData] = useState(STATUS.ALL)
  const [productid, setProductid] = useState({
    _id: "",
    name:""
  })
  const statusdata = useRef();
  statusdata.current = STATUSWiseData

  const statusPass = useRef();
  statusPass.current = STATUSWiseData

  const columns = useMemo(() => {
    const LeadTime = (date) => {
      const time = date?.lead_time ? date?.lead_time : date?.logs?.length > 1 ? date?.logs[1]?.date : date?.updatedAt
      const momentDate = moment(time);
      if (!momentDate.isValid()) {
        return "";
      }
      const LeadTimeDate = momentDate.startOf("day");
      const CurrentDate = moment().startOf("day");
      const daysDifference = LeadTimeDate.diff(CurrentDate, "days");

      return daysDifference >= -10 ? "" : ((LDstatusButton === BUTTON_TYPE.Solved) || (STATUSWiseData === STATUS.YET_TO_RECEIVED)) ? "" : "red";

    };
    return [

      {
        id: 2,
        fieldName: "createdAt",
        label: "Query Created Date",
        align: "left",
        sort: true,
        renderValue: (params, setParams) => <Typography sx={{ color: LeadTime(params) }}>{moment(params.createdAt).format("DD/MM/YYYY")}</Typography>
      },
      {
        id: 8,
        fieldName: "updatedAt",
        label: "Query Updated Date",
        align: "left",
        sort: true,
        renderValue: (params, setParams) => <Typography sx={{ color: LeadTime(params) }}>{moment(params.updatedAt).format("DD/MM/YYYY")}</Typography>
      },
      {
        id: 1,
        fieldName: "ticket_no",
        label: "Ticket No",
        align: "left",
        sort: true,
        renderValue: (params, setParams) => <Typography sx={{ color: LeadTime(params) }}>{params?.ticket_no}</Typography>
      },
      {
        id: 3,
        fieldName: "customer_name",
        label: "Customer Name",
        align: "left",
        sort: true,
        renderValue: (params, setParams) => <Typography sx={{ color: LeadTime(params) }}>{toTitleCase(params?.customer_name)}</Typography>
      },
      {
        id: 5,
        fieldName: "customer_phone",
        label: "Phone",
        align: "left",
        sort: true,
        renderValue: (params, setParams) => <Typography sx={{ color: LeadTime(params) }}>{params?.customer_phone}</Typography>
      },
      {
        id: 4,
        fieldName: "box_id",
        label: "Box Id",
        align: "left",
        sort: true,
        renderValue: (params, setParams) => <Typography sx={{ color: LeadTime(params) }}>{params?.box_id}</Typography>
      },
      {
        id: 6,
        fieldName: "new_box_id",
        label: "New Box Id",
        align: "left",
        sort: true,
        hide: STATUSWiseData !== STATUS.REPLACEMENT_COMPLETE,
        renderValue: (params, setParams) => <Typography sx={{ color: LeadTime(params) }}>{params.new_box_id ? params.new_box_id : "NA"}</Typography>
      },

      {
        id: 9,
        fieldName: "",
        label: "Time",
        align: "center",
        justify: "center",
        sort: false,
        hide: LDstatusButton === BUTTON_TYPE.Solved,
        renderValue: (params) => {
          const leadTimeDate = params?.lead_time ? moment(params.lead_time) : params?.logs?.length > 1 ? moment(params?.logs[1]?.date) : moment(params?.updatedAt)
        
          if (!leadTimeDate || !leadTimeDate.isValid()) return <Typography>NA</Typography>;

          const deadline = leadTimeDate.clone().add(10, 'days').startOf('day');
          const today = moment().startOf('day');
          const daysLeft = deadline.diff(today, 'days');

          return (
            <Typography sx={{ color: !LeadTime(params) == "" ? "red" : "green" }}>
              {daysLeft >= 0 ? `${daysLeft} days left` : <Chip label={"Over Due"} sx={{ color: "white", backgroundColor: "rgba(224, 20, 20, 0.8)" }} />}</Typography>
          );
        }
      },

      {
        id: 7,
        fieldName: "",
        label: "Action",

        align: "right",
        renderValue: (params, setParams) => (
          <ActionComponent
            params={params}
            setParams={setParams}
            statusPass={statusPass.current} />
        ),
      },
    ]
  }, [STATUSWiseData, LDstatusButton]
  );

  const [filters, setFilters] = useState({
    pageNo: 1,
    pageSize: 10,
    search: "",
    searchable: ['customer_name', 'box_id', 'customer_phone', 'ticket_no'],
    role: "",
    sort: "updatedAt",
    sortDirection: -1,
  });

  const [loading, setLoading] = useState(false);
  const [loadingCount, setLoadingCount] = useState(false);

  const statusData = useSelector((state) => state)
  const list = useRef();
  list.current = statusData.statusReducer.status_data

  const fetchList = useCallback(() => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await getRepairingTicketApi({ ...filters, status_role: STATUSWiseData, product_id: productid?._id ,parentStatus:LDstatusButton}),
        (response) => {
          dispatch(statusAction(response));
          setLoading(false);
        },
        (err) => {
          setLoading(false);
        }
      )
    );
  }, [dispatch, filters, STATUSWiseData, productid?._id,LDstatusButton]);

  const [CountStatus, setCountStatus] = useState()

  const fetchCountDataAll = useCallback(() => {
    setLoadingCount(true);
    dispatch(
      callApiAction(
        async () => await StatusCountChangeApi({ role: USER_ROLES.LD, product_id: productid?._id }),
        async (response) => {
          setCountStatus({ response });

          setLoadingCount(false);
        },
        (err) => {
          setCountStatus({ err });
          setLoadingCount(false);
        }
      )
    );
  }, [dispatch, productid?._id])

  useEffect(() => {
    if (JSON.stringify(filters) === JSON.stringify(statusData.statusReducer.filters)) {
      fetchList();
    } else {
      dispatch(statusActionFilters(filters));
    }
  }, [dispatch, fetchList, STATUSWiseData, statusData.statusReducer.filters, filters, productid?._id]);


  useEffect(() => {
    if (statusData.statusReducer.Count !== -1 || productid?._id) {
      fetchCountDataAll();
    } else {
      dispatch(statusCountActionFilters(1));
    }
  }, [dispatch, statusData.statusReducer.Count, fetchCountDataAll, productid?._id])

  return (
    <DashboardPageUI
      CountStatus={CountStatus}
      columns={columns}
      list={list.current}
      loading={loading}
      loadingCount={loadingCount}
      filters={filters}
      setFilters={setFilters}
      LDstatusButton={LDstatusButton}
      setLDstatusButton={setLDstatusButton}
      setSTATUSWiseData={setSTATUSWiseData}
      STATUSWiseData={STATUSWiseData}
      setProductid={setProductid}
      productid={productid}
    />
  )
}

export default DashboardPageControllerLD